import type { IngatlanTipus } from './tipusok.ts';

const ALLAPOT = ['uj_szeru', 'felujitott', 'reszben_felujitott', 'atlagos', 'felujitando'] as const;
/** AA–BB / CC–EE / FF–JJ besorolás; az `atlagos` és a `nem_tudom` nem módosítja az árat. */
const ENERGETIKA = ['korszeru', 'atlagos', 'korszerutlen', 'nem_tudom'] as const;

/**
 * Kanonikus jellemzők. A varázsló (F1b) ezekből épít kérdéseket, a lead-séma ezekre validál,
 * a `szorzok` tábla ezekre a kulcs–érték párokra hivatkozik.
 */
export const JELLEMZOK: Record<IngatlanTipus, Record<string, readonly string[]>> = {
  lakas: {
    allapot: ALLAPOT,
    emelet: ['foldszint', '1_2', '3_felett_lifttel', '3_felett_lift_nelkul'],
    erkely: ['van', 'nincs'],
    parkolas: ['sajat', 'utcai'],
    energetika: ENERGETIKA,
  },
  haz: {
    allapot: [...ALLAPOT, 'bontando'],
    falazat: ['tegla_blokk', 'valyog', 'konnyuszerkezet', 'egyeb'],
    energetika: ENERGETIKA,
    parkolas: ['garazs', 'beallo', 'nincs'],
  },
  iroda: { allapot: ALLAPOT, kategoria: ['A', 'B', 'C', 'nem_tudom'] },
  ipari: { allapot: ALLAPOT, kategoria: ['raktar', 'csarnok', 'muhely'] },
  telek: { belterulet: ['igen', 'nem', 'nem_tudom'], kozmu: ['teljes', 'reszleges', 'nincs'] },
  garazs: { fajta: ['beallo', 'onallo'] },
};

export function jellemzokErvenyesek(tipus: IngatlanTipus, j: Record<string, string>): boolean {
  const lista = JELLEMZOK[tipus];
  return Object.entries(j).every(([k, v]) => lista[k]?.includes(v) === true);
}
